import { CitationSourcesList } from '../Citation/CitationSourcesList';
import { jsx as _jsx } from "react/jsx-runtime";
export const CitationPanelSources = ({
  citation
}) => {
  return /*#__PURE__*/_jsx(CitationSourcesList, {
    sources: citation.citations
  });
};